export const ANCHORS = {
  complementaries: 'produtos-complementares',
  characteristics: 'caracteristicas-tecnicas',
  fullDescription: 'descricao-do-produto',
  reviews: 'avaliacoes',
};
